import React from "react";
import { CountCardProps } from "../../service/interfaces/Components";

const CountCard: React.FC<CountCardProps> = ({
  label,
  count,
  backgroundColor = "#5A8DEE", // Default blue background
  textColor = "white", // Default white text
  className = "",
  classNameLabel = "",
  classNameCount = "",
}) => {
  return (
    <div
      className={`flex items-center gap-4 justify-between px- p-3 rounded-[20px]   ${className}`}
      style={{ backgroundColor }}
      aria-label={`Card displaying ${label} with count ${count}`}
    >
      {/* Label */}
      <span
        className={`text-[14px] font-[400] ${classNameLabel}`}
        style={{ color: textColor }}
      >
        {label}
      </span>

      {/* Count */}
      <span
        className={`text-[20px] font-[500] ${classNameCount}`}
        style={{ color: textColor }}
      >
        {count}
      </span>
    </div>
  );
};

export default CountCard;
